<template>
	<div style="background-color:#fffcf7;" class="container">
		<div
			class="col-lg-12 col-md-12 col-sm-12 col-xs-12 p-3 border-15 shadow bg-white text-center"
			data-aos="flip-up"
			data-aos-easing="ease-out-cubic"
			data-aos-duration="2000"
			style="
			display: flex;
			align-items: center;
			justify-content: center;
			align-content: center;
			"
		>
			<div style="width: 75%; max-width: 500px;">
				<h2 class="text-center bMikhak">
					ثبت نام و ورود استاد
				</h2>
				<textInput
					type="number"
					:val="val && val.mobile && val.mobile"
					placeholder="تلفن همراه"
					label="تلفن همراه"
					leading="برای ثبت نام در ایزی تیک از شماره موبایلی که به نام کدملی شما ثبت شده است، استفاده کنید."
					@inputTxtFunc="(e)=>{ val.mobile = e }"
					@enter="( !validatePhone(val.mobile) ) ? '' : sav() "
				/>
				<p class="mt-3">
					ثبت نام شما به منزله پذیرش
					<router-link 
							to="/rules"  
							class="text-success under-line"
							style="font-size: 1rem; text-decoration-color: #397972;"
							>
							قوانین و مقررات
						</router-link>
					می باشد.
				</p>
				<btn
					@clickMe="sav()"
					class="w-100 mt-3"
					textClass="w-100"
					text="ثبت نام"
				/>
				<br/>
				<br/>
				<div class="overflow-hidden" v-if="chechRole()">
					<div class="float-right" style="display: flex; align-items: center; height: 40;">
						قبلا ثبت نام کرده اید؟&nbsp;
						<router-link 
							to="/oneTimePassword"  
							class="text-success under-line"
							style="font-size: 1rem; text-decoration-color: #397972;"
							>وارد</router-link>
						شوید
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import textInput from  "../../UI/input/textInput.vue";
	import btn from  "../../UI/button/btn.vue";
	import { validatePhone, indexFinder } from  "../../assets/library/filter.js";
	import { textRule } from  "../../assets/text/rule.js";
	import { error } from  "../../assets/library/messege.js";


	export default {
		name: 'teachers_id',
		data(){
			return {
				error: error,
				validatePhone: validatePhone,
				indexFinder: indexFinder,
				textRule: textRule,
				imgurl: window.imgurl,
				baseurl: window.baseurl,
				flds: [],
				degrees: [],
				category: [],
				location: [],
				val:{
					"page": 0,
					"mobile": "",
				},
			}
		},
		components: {
			btn,
			textInput,
		},
			props: [],
		mounted(){
			this.$swal.close();
		},
		methods:{
			showRule(THIS = this){
				var index_text = this.indexFinder(this.$localStorage.get('settings'), "3");
				THIS.$swal.fire({
					position: 'center',
					type: '',
					html: "<p class='text-justify'>" + this.$localStorage.get('settings')[index_text].dsc + "</p>" ,
					width: '80%',
					title: this.$localStorage.get('settings') && this.$localStorage.get('settings')[index_text] && this.$localStorage.get('settings')[index_text].title ? this.$localStorage.get('settings')[index_text].title : "",
					showCloseButton: true,
					showConfirmButton: true,
					confirmButtonText: "بستن",
				});
			},
			// *********************************************************************
			chechRole(){
				let user = this.$localStorage.get('user');
				if(user == null){
					return true;
				}else if(user.username && user.username.roll && user.username.role != 3){
					return true;
				}else{
					return false;
				}
			},
			// *********************************************************************
			sav(THIS=this){
				if(this.val && this.val.mobile && this.val.mobile==""){
					THIS.error(THIS, 'اطلاعات را تکمیل نمایید');
				} else if(!this.validatePhone(this.val && this.val.mobile)){
					THIS.error(THIS, 'شماره موبایل اشتباه است');
				} else {
					window.$.post(THIS.baseurl + "user/check", { token: this.$localStorage.get("user"), teacherPhone: this.val.mobile }, function(D){
						THIS.val.page = 1;
						THIS.$emit('next_page', THIS.val);
						// if(D.data == '0'){
						// }else{
						// 	THIS.val.mobile = '';
						// 	THIS.error(THIS, 'شماره تماس وارد شده قبلا در سیستم ثبت نام کرده است')
						// }
					}, "json");
				}
			},
			// *********************************************************************
		}
	}
</script>
<style>

</style>
